<p-toast position="top-right"></p-toast>
<p-confirmDialog #cdrsl [style]="{width: '600px'}" key="rsl-dialog">
  <p-footer>
    <button type="button" pButton accesskey="d" icon="pi-fw fas fa-trash-alt" class="p-button-raised p-button-danger" label="Yes" (click)="cdrsl.accept()"></button>
    <button type="button" pButton icon="pi pi-times" class="p-button-raised p-button-outlined" label="No" (click)="cdrsl.reject()"></button>
  </p-footer>
</p-confirmDialog>

<div>
  <button pButton pRipple label="Add Summary" class="p-button-primary p-ml-3" icon="fas fa-align-justify" (click)="addOrUpdateRosterSummaryLine(null)"></button>
  <button pButton pRipple label="Collapse All" class="p-button-primary p-ml-3" icon="fas fa-angle-double-up" [disabled]="collapseAll" (click)="collapseAll = true;"></button>
  <button pButton pRipple label="Expand All" class="p-button-primary p-ml-3" icon="fas fa-angle-double-down" [disabled]="!collapseAll" (click)="collapseAll = false;"></button>
</div>

<div class="p-m-3 roster-summary-line" *ngFor="let rsl of rosterSummaryLines; let i=index">
  <p-fieldset legend="{{getRosterProject(rsl.rosterProjectId)?.title}}: {{rsl.title}} - {{rsl.active ? 'Active' : 'Inactive'}} - Sort No: {{rsl.sortNo}}" 
    [styleClass]="rsl.active ? 'active' : 'inactive'"
    [collapsed]="collapseAll"
    [toggleable]="true">

    <div class="text-left p-mb-2" *ngIf="rsl.groupIds.length >= 5">
      <button pButton pRipple label="Edit" class="p-button p-mr-2" icon="pi pi-pencil"
              (click)="addOrUpdateRosterSummaryLine(rsl)"></button>
      <button pButton pRipple label="Delete" class="p-button-danger" icon="pi pi-times" 
              [title]="'Delete roster summary line'"
              (click)="deleteRosterSummaryLine(rsl)"></button>
    </div>

    <p-table [value]="rsl.groupIds" 
      styleClass="p-datatable-gridlines"
      [tableStyle]="{width: 'auto'}">
      <ng-template pTemplate="header">
        <tr>
          <th class="bg-light-yellow" style="width:400px">
            <i class="fas fa-info-circle mr-2" style="color: red; font-weight: bold; font-size: 1.2rem;" aria-hidden="true"></i>
            <span *ngIf="rsl.groupIds.length > 0">
              Only employees within company codes [{{getEmployersInCommaSeperatedString(rsl.companyCode)}}] and in the work groups listed below will be counted.
            </span>
            <span *ngIf="rsl.groupIds.length === 0">Click Edit button to add work groups</span>
          </th>
          <th class="bg-light-yellow" style="width:50px"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-groupId>
        <tr>
          <td style="width:400px"><i class="fas fa-user-friends fa-lg"></i> <span class="p-ml-3">{{workGroupsDict[groupId].name}}</span></td>
          <td style="width:50px" class="text-center">
            <button pButton pRipple type="button" icon="fas fa-trash-alt fa-lg" class="p-button-rounded p-button-danger p-button-text" 
                    pTooltip="Detach {{workGroupsDict[groupId].name}}"
                    (click)="deleteGroup(i, rsl.id, groupId)"></button>
          </td>
        </tr>
      </ng-template>
    </p-table>    

    <div class="text-left p-mt-2">
      <button pButton pRipple label="Edit" class="p-button p-mr-2" icon="pi pi-pencil"
              (click)="addOrUpdateRosterSummaryLine(rsl)"></button>
      <button pButton pRipple label="Delete" class="p-button-danger" icon="pi pi-times" 
              [title]="'Delete roster summary line'"
              (click)="deleteRosterSummaryLine(rsl)"></button>
    </div>
  </p-fieldset>
</div>

